import { render, staticRenderFns } from "./object-cards.vue?vue&type=template&id=2b2bda1f"
import script from "./object-cards.vue?vue&type=script&lang=js"
export * from "./object-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports